import { render } from "./SettingsDemo.vue?vue&type=template&id=08684472&scoped=true"
import script from "./SettingsDemo.vue?vue&type=script&lang=js"
export * from "./SettingsDemo.vue?vue&type=script&lang=js"

import "./SettingsDemo.vue?vue&type=style&index=0&id=08684472&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08684472"]])

export default __exports__